export const environment = {
  production: true,
  basePath: '/consignment',
  apiPath: '/consignment/api/v1',
  logoSrc: '/consignment/assets/images/calloffprod.png',
  requiredTruckFillPercent: 3,
  packetLengths: [180, 210, 240, 270, 300, 330, 360, 390, 420, 450, 480, 510, 540, 570, 600],
  minimumCartItemsForLoadPlanning: 8,
  minimumOpenPackagesForFloatingHeader: 7,
  debugLogging: true,
  certificateCodeType: 'certificateCode',
  minPrice: 50,
  maxPrice: 2000, 
};
